import styled from "styled-components";

export const ContainerWithPadding = styled.div`
  width: 100%;
  display: flex;
  padding-top: 5rem;
  justify-content: center;
  min-height: calc(100vh - 14.75rem);
`;
